import React from 'react';
import { PropTypes } from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Btn from '../../../components/Btn';

import './signin.css';

export default class SignIn extends React.Component {
    toggleSignInInputVisiblity() {
        const { setSignInIsVisible, isVisible, clearAuthError } = this.props;
        setSignInIsVisible(!isVisible);
        clearAuthError(null);
    }

    handleEmailChange(event) {
        const { setEmail, clearAuthError } = this.props;
        setEmail(event.target.value);
        clearAuthError();
    }

    handlePasswordChange(event) {
        const { setPassword, clearAuthError } = this.props;
        setPassword(event.target.value);
        clearAuthError();
    }

    handleSubmit = (e) => {
        const {
            signIn,
            email,
            password,
        } = this.props;
        e.preventDefault();
        signIn(email, password);
    }

    render() {
        const { isVisible, authError } = this.props;
        return (
            <div>
                <Btn
                    className="loginBtn"
                    fullWidth={false}
                    size="large"
                    variant="outlined"
                    color="primary"
                    onClick={(e, value) => this.toggleSignInInputVisiblity(value)}
                    label="Log In"
                />
                <Dialog
                    open={isVisible}
                    onClose={(e, value) => this.toggleSignInInputVisiblity(value)}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Email Address"
                            type="email"
                            fullWidth
                            color="secondary"
                            onChange={event => this.handleEmailChange(event)}
                        />
                        <TextField
                            margin="dense"
                            label="Password"
                            type="password"
                            color="secondary"
                            fullWidth
                            onChange={event => this.handlePasswordChange(event)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Btn
                            onClick={(e, value) => this.toggleSignInInputVisiblity(value)}
                            label="Cancel"
                            color="secondary"
                        />
                        <Btn
                            onClick={this.handleSubmit}
                            label="Sign In"
                            type="submit"
                        />
                    </DialogActions>
                    <div className="error">
                        { authError ? <p>{authError}</p> : null }
                    </div>
                </Dialog>
            </div>
        );
    }
}
SignIn.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    setSignInIsVisible: PropTypes.func.isRequired,
    signIn: PropTypes.func.isRequired,
    authError: PropTypes.string,
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    setPassword: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    clearAuthError: PropTypes.func.isRequired,
};

SignIn.defaultProps = {
    authError: null,
};



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignIn/SignIn.js